var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSql(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "585.918px",
    height: "585.918px",
    viewBox: "0 0 585.918 585.918",
    style: {
      enableBackground: "new 0 0 585.918 585.918"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M170.398,259.672c-17.877,0.748-27.977,19.158-27.977,41.387c-0.167,22.577,10.266,40.062,27.801,40.397 c18.184,0.354,29.005-17.29,29.005-41.568C199.228,277.245,188.761,258.909,170.398,259.672z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.176,46.206v492.311l346.22,47.401v-50.583c0.776,0.053,1.542,0.115,2.329,0.115h177.39 c20.756,0,37.627-16.888,37.627-37.628V86.602c0-20.743-16.871-37.628-37.627-37.628h-177.39c-0.787,0-1.553,0.076-2.329,0.123V0 L11.176,46.206z M63.135,359.296c-11.258-0.4-22.174-4.036-27.562-7.622l4.399-20.363c5.847,3.507,14.948,7.108,24.493,7.287 c10.437,0.189,16.032-4.583,16.032-11.979c0-7.065-4.85-11.097-16.911-15.906c-16.326-6.32-26.743-16.282-26.743-32.187 c0-18.663,13.732-33.732,37.155-35.087c11.518-0.667,20.145,1.56,26.381,4.286l-5.299,21.2c-4.176-2.056-11.546-4.974-21.522-4.564 c-9.838,0.405-14.541,5.555-14.541,11.336c0,7.103,5.596,10.113,18.604,15.336c18.228,7.134,27,17.634,27,33.916 C104.621,344.313,91.048,360.287,63.135,359.296z M221.381,384.709c-17.788-6.059-32.263-12.017-48.203-19.545 c-2.611-1.176-5.396-1.815-8.171-2.095c-25.764-2.672-48.953-22.824-48.953-60.856c0-34.924,20.874-62.402,55.035-64.381 c36.912-2.129,58.027,25.985,58.027,60.576c0,28.766-13.342,48.772-29.711,55.759v0.734c9.519,3.051,20.283,5.628,30.281,8.017 L221.381,384.709z M335.463,366.881l-87.121-2.96V235.472l30.48-1.708v106.278l56.641,0.955V366.881z M359.726,70.48h177.39 c8.893,0,16.125,7.236,16.125,16.127v411.215c0,8.893-7.232,16.127-16.125,16.127h-177.39c-0.797,0-1.563-0.111-2.329-0.232 V399.438h16.126v-11.77h-16.126v-29.345h9.164v-11.764h-9.164v-62.725h15.841v-11.767h-15.841V210.01h48.938v-11.767h-48.938 V70.722C358.157,70.604,358.929,70.48,359.726,70.48z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.548,
    y: 234.596,
    width: 38.153,
    height: 11.766
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.855,
    y: 234.596,
    width: 38.157,
    height: 11.766
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.603,
    y: 272.069,
    width: 43.703,
    height: 11.767
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.504,
    y: 272.069,
    width: 43.696,
    height: 11.767
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.732,
    y: 310.261,
    width: 18.54,
    height: 11.769
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.743,
    y: 310.261,
    width: 18.54,
    height: 11.769
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.407,
    y: 310.261,
    width: 18.54,
    height: 11.769
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.418,
    y: 310.261,
    width: 18.53,
    height: 11.769
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.353,
    y: 310.261,
    width: 18.541,
    height: 11.769
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.369,
    y: 310.261,
    width: 18.539,
    height: 11.769
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.027,
    y: 310.261,
    width: 18.541,
    height: 11.769
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520.044,
    y: 310.261,
    width: 18.529,
    height: 11.769
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.506,
    y: 346.555,
    width: 26.363,
    height: 11.77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.777,
    y: 346.555,
    width: 26.361,
    height: 11.77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.084,
    y: 346.555,
    width: 26.368,
    height: 11.77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.903,
    y: 346.555,
    width: 26.374,
    height: 11.77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.222,
    y: 346.555,
    width: 26.356,
    height: 11.77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.423,
    y: 387.669,
    width: 21.018,
    height: 11.765
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.383,
    y: 387.669,
    width: 21.004,
    height: 11.765
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.924,
    y: 387.669,
    width: 21.009,
    height: 11.765
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.885,
    y: 387.669,
    width: 21.009,
    height: 11.765
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/sql.6891d2ce40aaa17213d9b2fe88339dc9.svg";
export { ForwardRef as ReactComponent };